import { Injectable, Renderer2, RendererFactory2   } from '@angular/core';
import { GlobalsService } from './globals.service';
import { MenuController} from '@ionic/angular';
import { ToastController, AlertController } from '@ionic/angular';
import { DatePipe } from '@angular/common';

import { Clipboard } from '@capacitor/clipboard';

// import { AES256 } from '@awesome-cordova-plugins/aes-256/ngx';

@Injectable({providedIn: 'root'})
export class Els {

private renderer: Renderer2;

isNumber = (n: string | number): boolean => !isNaN(parseFloat(String(n))) && isFinite(Number(n));
delay = ms => new Promise(res => setTimeout(res, ms));

constructor(
// private aes256: AES256,
private datepipe: DatePipe,
public alert: AlertController,
private gs: GlobalsService,
private _renderer: RendererFactory2,
public toastController: ToastController,
private menuController: MenuController,
) {this.renderer = _renderer.createRenderer(null, null);}

async getClip (str) {
    await Clipboard.write({ string: str });
}

goScrollToTop(point) {
    var content = document.querySelector('ion-content') as HTMLIonContentElement ;
    // if (point == 0 ) content.scrollToPoint(0,  100, 500);
     content.scrollToTop(500);
}

getScrolPos (e: HTMLElement) {
    let s = window.innerHeight + ' > ' + e.scrollHeight + ' > ' + e.offsetTop + ' > ' + e.offsetHeight + ' > ' + e.offsetWidth ;
    let ss = e.scrollHeight + ' > ' + e.scrollWidth + ' > ' + e.clientHeight + ' > ' + e.clientWidth;
    console.log( s + ' = ' + ss);
    // this.scrollToTop(200);
}


deleteElement (id) {
    let ac = document.getElementById (id); 
    if (ac === null) { console.error('Id not found: ' + id); return;}
    ac.parentNode.removeChild(ac);
}
hideUnhideElement (id, display) {
    var el = document.getElementById(id); 
    if (el != null) { el.setAttribute('style', 'display:' + display + ';'); return 1} else {console.error (id + ' NOT FOUND')}
    return 0;
}
clearInnerHTML (id) {
    let d = document.getElementById (id);
    if (d === null) {console.error('not found! ' + id); return d;}
    d.innerHTML = '';
    return d;
}
addRemClass (id, cls, add: number) {
    let  e = document.getElementById (id);
    this.addRemClass_e (e, cls, add);
}
addRemClass_e (e, cls, add: number) {
    if (e === null) {
        console.error('Id not found ' + e); return;}
    if (add == this.gs.hideByClass) { e.classList.add (cls);  } 
    if (add == this.gs.showByClass) { e.classList.remove (cls);  } 
}
setIconName (name, av) {
    if (name == '' || av === null) return '';
    if (name.indexOf('/') > -1) this.renderer.setAttribute(av, 'src', name);
    else  this.renderer.setProperty(av, 'name', name);
}
ifDispBlock (id) {
    var d = document.getElementById(id);  
    if (d === null)  return 0;
    if (d.style.display == 'block') return 1;
    return 0;
}
setInnerHDat (id, v) {
    let e = document.getElementById(id);
    if (e !== null) {e.innerHTML = v; return e;}
    console.error ('Can not find ' + id);
    return '';
}

// CREATE HTML ELEMENTS      ////$$$
createElem (type, id?, inHtml?, txt?, cls?) {
    if (type === 'txt') {return this.renderer.createText(txt);}
    const e = this.renderer.createElement(type);
    if (id && id !== '') {this.renderer.setProperty(e, 'id', id);}
    if (inHtml && inHtml !== '') {e.innerHTML = inHtml;}
    if (cls && cls !== '') {this.renderer.addClass(e, cls);}
    return e;
}

createInputEl (s, val, size, hide) {
    let e = this.getEL ('ion-input ;; value = ' + val + ' ;; size = ' + size);
    if (hide == 1) e.style.display = 'none';
    e.addEventListener("ionChange", () => { this.getTrfDestChange(s); });
    return e;
}

createCheckEl (id, val) {
    let e = this.createElem ('ion-checkbox', id) as HTMLIonCheckboxElement ;
    if (val == '1') e.checked = true;
    e.addEventListener("ionChange", () => { this.getTrfDestChange( id ); });
    return e;
}

insertItmRow (id, rr, e) {
    if (e === undefined) {console.error(rr + id); return;}
    var ac = this.clearInnerHTML (rr + id);  if (ac === null) return;
    this.renderer.appendChild(ac, e);
}
appendCol (row, id, size, inHtml, cls) {
    const e = this.createElem ('ion-col', id, inHtml);
    if (size != '') this.renderer.setProperty(e, 'size', size);
    if (cls != '') this.renderer.setAttribute(e, 'class', cls);
    this.renderer.appendChild(row, e);
    return e;
}
getAudioEl (src, format, id) {
    // import {normalizeURL} from 'ionic-angular'; for ios ?  style="width:100%;"
    const audio = this.createElem ('audio');
    this.renderer.setProperty(audio, 'preload', 'true');
    this.renderer.setAttribute(audio, 'controls', 'true');
    this.renderer.setAttribute(audio, 'style', 'height:32px');
    const source = this.createElem ('source'); 
    this.renderer.setProperty(source, 'src', src);
    if (format == 1) this.renderer.setAttribute(source, 'type', 'audio/wav');
    if (format == 2) this.renderer.setAttribute(source, 'type', 'audio/mpeg');
    this.renderer.appendChild(audio, source);
    return audio;
}
getAudioList ( src ) { 
    let div = this.clearInnerHTML ('uvmAud'); if (div === null) return;
    console.log(this.gs.uvmGrsA)
    for (let i = 0; i < this.gs.uvmGrsA.length; i++) {
        if (this.gs.uvmGrsA[i]['disp'] == src) {
            let e = this.getAudioEl ( this.gs.uvmGrsA[i]['ser'] + this.gs.uvmGrsA[i]['fn'], this.gs.uvmGrsA[i]['format'], '');
            this.renderer.setAttribute(e, 'style', 'max-height: 32px; margin: 10px; width: 80%;');
            this.renderer.appendChild(div, e);
            this.getTrfDestChange('uvmAud');
            return;
        }
    }
}

X_clicked (divID) {
    if (divID.indexOf('sms_') == 0) {
        if (divID == 'sms_g') this.sh_dsms (this.gs.hideByClass);
        else { this.deleteElement(divID) }
        return;
    }        

    switch (divID) {
    case 'didsIdsub':     // case 'trf0': 
        this.clearInnerHTML ('dsac'); 
        this.clearInnerHTML (divID);
        this.sh_allTopDivs (this.gs.hideByClass);
    break;
    }
}
getX_bar (id) {
    let div = this.createElem ('div');
    let tool = this.createElem ('ion-header');
    this.renderer.setProperty(tool, 'style', 'text-align: end');
    let ico = this.getEL ('ion-icon ;; name = ' + this.gs.ICO_X + ' ;; class = x-ico' );
    ico.addEventListener("click", () => { this.X_clicked (id); });
    this.renderer.appendChild(tool, ico);
    this.renderer.appendChild(div, tool);
    return div;
}
getXicon (name) {
    let but = this.createElem ('button');
    let es = 'ion-icon ;; name = ' + name + ' ;; class = x-ico ;; color = primary';
    this.renderer.appendChild(but, this.getEL ( es));
    return but;
}

getItLblEl (id, val, cls) {
    const div = this.createElem ('div', id); 
    let item = this.getEL ('ion-item ;; class = ' + cls);
    this.renderer.appendChild(item, this.createElem ('ion-lable', '', val));
    this.renderer.appendChild(div, item);
    return div;
}

getDateStr (da, isHistory) {
    let br = isHistory == 1 ? ' ' : '<br/>';
    const l = this.createElem ('ion-lable', '', '', '', 'smspreR');
    const date = this.gs.getLocalTime (da);

    if (date.getDate() == this.gs.today.getDate()) {
        if ( date.getMonth() == this.gs.today.getMonth() && date.getFullYear() == this.gs.today.getFullYear()) {
            l.innerHTML = 'Today' + br + this.datepipe.transform(date, 'h:mm a'); 
            l.style = 'font-weight: bold;';
            return l;
        }  
    }
    if (date.getDate() == this.gs.yesterday.getDate()) {
        if ( date.getMonth() == this.gs.yesterday.getMonth() && date.getFullYear() == this.gs.yesterday.getFullYear()) {
            l.innerHTML = 'Yesterday' + br + this.datepipe.transform(date, 'h:mm a'); return l;
        }  
    }

    let s = ''; let len = 6;
    let dy = date.toLocaleString('en-us', {weekday:'short'});
    
    if ((date.getFullYear() - this.gs.today.getFullYear()) > 0) {
        s = this.datepipe.transform(date, 'yyyy mm dd h:mm a'); len = 11; }
    else {s = this.datepipe.transform(date, 'MMM dd h:mm a');}
    
    l.innerHTML = dy + ' ' + s.substring(0, len) + br + s.substring (len);
    return l;
}


////$$$$    MAIN DIVS ELEMENTS

sh_allTopDivs (vis) {
    this.sh_msgFiltsID (vis);
    this.sh_DIDsDivs (vis);
}
sh_DIDsDivs (vis) {
    this.sh_filterDivId (vis);
    this.addRemClass ('DIDsDivId', "hideEl", vis);
    this.addRemClass ('topTabId', "hideEl", vis);
}
sh_msgsDiv () {
    let vis = this.gs.showByClass;
    this.sh_msgFiltsID (this.gs.showByClass);
                    this.sh_dmain (vis);
                    this.sh_loginDiv (this.gs.hideByClass);
}
sh_loginDiv (vis) {     this.addRemClass ('loginDiv', "hideEl", vis); }
sh_dmain (vis) {        this.addRemClass ('dmain', "hideEl", vis); }
sh_filterDivId (vis) {  this.addRemClass ('filterDivId', "hideEl", vis); }
sh_msgFiltsID (vis) {   this.addRemClass ('msgFiltsID', "hideEl", vis); }
sh_mainH (vis) {        this.addRemClass ('mainH', "hideEl", vis); }
sh_dsms (vis) {         this.addRemClass ('dsms', "hideEl", vis); this.clearInnerHTML ('dsms'); }
sh_segbid (ii, vis) {   this.addRemClass ('segbid_' + ii, "hideEl", vis); }

showLoginDivs () {
    let vis = this.gs.hideByClass;
    this.sh_allTopDivs (vis);
    this.sh_dsms (vis);
    this.sh_filterDivId (vis);
    this.sh_dmain (vis);
    this.sh_mainH (vis);

    this.sh_loginDiv (this.gs.showByClass);
}

// MESSAGE DISPLAY ELEMENTS      ////$$$
createLisE  (ind: number, a, dr) {
    let aaa = this.createLisCap (a, this.gs.ITMS[ind]['a'][this.gs.conOffS]);
    let cap = aaa[1];
    let row = this.createElem ('ion-row');
    // this.renderer.appendChild(row, this.createMsgImage());
    
    let col = this.appendCol (row, '', '7', '', '');
    let row1 = this.createElem ('ion-row', 'cap1_'  + this.gs.getID (ind), aaa[2]);
    let row2 = this.createElem ('ion-row', 'cap2_'  + this.gs.getID (ind), cap.slice (0, 42), '', 'smspreL');
    this.renderer.appendChild(col, row1);
    this.renderer.appendChild(col, row2);
    
    this.appendCol (row, '', '', '<br/>' + aaa[3], 'smspreR');

    let grid = this.createElem ('ion-grid');
    this.renderer.appendChild(grid, dr);
    this.renderer.appendChild(grid, row);
    return grid;
}

getAvName_format (a) {
    let ic = this.gs.getICON ();

    if (a['p_fix'] == 'r_') { 
        switch (a['type']) {
            case this.gs.CDRS_TYPE_PSTN_OUT: ic.name = this.gs.ICO_OUTCALL; break;
            case this.gs.CDRS_TYPE_PSTN_IN: ic.name = this.gs.ICO_INCALL; break;
            // case this.gs.CDRS_TYPE_FAX_IN: ic.name = this.gs.ICO_FAX; break;
            default: break;
        }
    }

    if (a['p_fix'] == 'm_') {
        switch (a['type']) {
          case this.gs.MSGS_TYPE_OUT_PSTN_CONV_REC: ic.name = this.gs.ICO_OUTCALL;  break;
          case this.gs.MSGS_TYPE_IN_PSTN_CONV_REC:  ic.name = this.gs.ICO_INCALL;   break;

          case this.gs.MSGS_TYPE_VOICEMAIL:
            switch (a['format']) {
                case this.gs.MSGS_FORMAT_WAV:  
                case this.gs.MSGS_FORMAT_MP3: ic.name = this.gs.ICO_RECORDING; break;
                case this.gs.MSGS_FORMAT_TIF:   
                case this.gs.MSGS_FORMAT_PDF:   
                case this.gs.MSGS_FORMAT_TIF_PDF: ic.name = this.gs.ICO_DOC; break;
                case this.gs.MSGS_FORMAT_TXT: ic.name = this.gs.ICO_CHAT; break;
                default: break;
            }
          break;

        default: break;
        }
    }
    return ic;
}

getAvName_type (a) {
    let ic = this.gs.getICON ();
    if (a['p_fix'] == 'r_') { ic.name = this.gs.ICO_DOC; return; }

    switch (a['type']) {
    case this.gs.MSGS_TYPE_VOICEMAIL:
        if (a['state'] == this.gs.MSGS_STATE_UNREAD) 
                ic.name = this.gs.ICO_MAIL;
        else    ic.name = this.gs.ICO_MAIL_OPEN;
        if (a['state'] == this.gs.MSGS_STATE_UNREAD) ic.color = 'primary';
        break;
    case this.gs.MSGS_TYPE_SENT: ic.name = this.gs.ICO_SEND; break;
    case this.gs.MSGS_TYPE_OUT_PSTN_CONV_REC: 
    case this.gs.MSGS_TYPE_IN_PSTN_CONV_REC: ic.name = this.gs.ICO_MIC; break;
    default: break;
    }
    return ic;
}

getAvName_flaged (ind) {
    let ic = this.gs.getICON ();
    if (this.gs.ITMS[ind]['a'][this.gs.ITMS[ ind ]['a'][this.gs.GT_flags_ind]] & this.gs.MSGS_FLAGS_FLAGGED) {
        ic.name = this.gs.ICO_FLG;
    }
    return ic;
}

getAvName_state ( ind, a) {
    let ic = this.gs.getICON ();
    ic.color = 'danger';
    if (a['state'] == this.gs.MSGS_STATE_DELETED) { ic.name = this.gs.ICO_TRASH; }
    else if (this.gs.ITMS[ind]['a'][this.gs.flags1_offset] & this.gs.PROFILE_FLAG_BLOCKED) { ic.name = this.gs.ICO_X; }
    return ic;
}

appendIconInCol (row, id, ic) {
    let col = this.appendCol (row, '', '1', '', '');
    let ico = this.getIconInCol (ic);
    this.renderer.appendChild(col, ico);
    this.renderer.appendChild(row, col);
}

getListStateBar (ind, gID, a) {
    
    let div = document.getElementById (gID + '_avs'); 
    if (div !== null) div.innerHTML = '';
    else div = this.createElem('div', gID + '_avs');

    let ic = this.getAvName_type (a); if (ic ) this.appendIconInCol (div, 'av1_'+gID, ic);
    ic = this.getAvName_format (a); if (ic) this.appendIconInCol (div, 'av2_'+gID, ic);
    ic = this.getAvName_flaged (ind); if (ic) this.appendIconInCol (div, 'av3_'+gID, ic);
    ic = this.getAvName_state (ind, a); if (ic) this.appendIconInCol (div, 'av4_'+gID, ic);

    let id = gID + '_topR';
    let topRow = document.getElementById (id); 

    if (topRow !== null) topRow.innerHTML = '';
    else topRow = this.createElem ('ion-row', id);

    this.renderer.appendChild(topRow, div);

    let dest = a['dest']; if (this.gs.ITMS[ind]['a'][this.gs.conOffS] == dest) dest = a['from'];
    const col = this.appendCol (topRow, '', '3', dest, 'smspreL');
    this.renderer.setAttribute(col, 'style', 'font-size:10px');

    const col2 = this.appendCol (topRow, '', '', '', 'smspreR');
    this.renderer.appendChild(col2, this.getDateStr (a['datetime'], 0));

    topRow.addEventListener("click", () => { this.setSelDID(dest); });
    return topRow;
}

getIconInCol (ic) {
    // let e = this.createElem('ion-i  con', id);
    // if (ic.name) this.setIconName (ic.name, e);
    // this.renderer.setProperty(e, 'color', ic.color);
    // if (clas == '') clas = 'x-ico';
    //this.renderer.setAttribute(e, 'class', clas);

    let name = ic.name ? ' ;; name = ' + ic.name : '';
    let es = 'ion-icon ;; color = ' + ic.color + ' ;; class = x-ico' + name;
    let ico = this.getEL ( es);

    return ico;
}

createLisCap  (a, conOffS) {
    let lent = ''; 
    let cap = this.gs.ifIsPhOrExt(conOffS, 1);
    
    let nam =  a['cname'];
    if (nam == '') {nam = cap; cap = '';}
    
    if (a['p_fix'] == 'm_') {
        switch (a['format']) {
        case this.gs.MSGS_FORMAT_WAV : case this.gs.MSGS_FORMAT_MP3 : {
            lent = this.gs.secondsToMinutes(a['len']); break;} 
        case this.gs.MSGS_FORMAT_TXT : { 
            cap = a['body'];
            lent = a['len'] + ' chrs'; 
            break; 
        } 
        case this.gs.MSGS_FORMAT_TIF: 
        case this.gs.MSGS_FORMAT_PDF: 
        case this.gs.MSGS_FORMAT_TIF_PDF : { lent = a['len'] + ' page(s)'; break;
        } default: break;
        }
    }
    else if (a['p_fix'] == 'r_') {
        switch(a['type'])  {
        case this.gs.CDRS_TYPE_PSTN_IN : {lent = 'Missed'; break;} 
        case this.gs.CDRS_TYPE_PSTN_OUT : {lent = 'OutCall'; break;} 
        case this.gs.CDRS_TYPE_FAX_IN : {lent = 'Fax'; break;} 
        default: break;
        }
        lent += ' ' + this.gs.secondsToMinutes(a['len']);
    }
    return ['', cap, nam, lent, conOffS];
}
getDocEl (a) {   // for pdf and tiff
    var f = 'https://' + a['url'].substring(0, a['url'].lastIndexOf('.') );
    const div = this.createElem ('div'); 
    const hrf = this.createElem ('a');
    const img = this.createElem ('img');
    let s =  "window.open('" + f + ".pdf', '_blank', 'location=yes'); return false;";
    this.renderer.setProperty(hrf, 'href', '#');
    this.renderer.setAttribute(hrf, 'onclick', s);
    this.renderer.setProperty(img, 'src', f + '.png');
    this.renderer.appendChild(hrf, img);
    this.renderer.appendChild(div, hrf);
    return div;
}

createMsgImage  () {
    let av = this.getEL ('ion-icon ;; name = ' + this.gs.ICO_PERSON + ' ;; class = img_chat' );
    let col = this.createElem ('ion-col');
    this.renderer.setAttribute(col, 'class', 'itms-cols');
    this.renderer.setAttribute(col, 'size', '1');
    this.renderer.appendChild(col, av);
    return col
}

showHis (ind: number, gID) {
    let c = 0;
    let user = this.gs.ITMS[ind]['a'][this.gs.conOffS].toLowerCase();
    let div = this.createElem ('div',  gID + '_shi');
    this.renderer.setAttribute(div, 'class', 'act-bar');
    this.gs.setTodayYesturday ();
  
    for(let ii = 0; ii < this.gs.ITMS.length; ii++){
        if (ii != ind) {
            let ss = this.gs.ITMS[ii]['a'][this.gs.conOffS].toLowerCase();
            if (ss.indexOf(user) > -1) { this.getHisRow (div, ii); c++; }
        }
    }
    
    this.insertItmRow (this.gs.clickedItemId, 'hr_', div);
    return c;
}
getHisRow (div, ii: number) {
   let row1 = this.createElem ('ion-row');
   let row2 = this.createElem ('ion-row', '', '', '', 'itemWhiteHistory');

    let a = this.gs.getAssocMsgArray (ii);

    let l = this.createElem ('ion-lable', '', this.createLisCap (a, this.gs.ITMS[ii]['a'][this.gs.conOffS])[3]);
    this.renderer.setAttribute(l, 'class', 'smspreR');
    this.renderer.setAttribute(l, 'style', 'width: 60%; text-align: left;');
    this.renderer.appendChild(row1, l);

    l = this.getDateStr (a['datetime'], 1);
    this.renderer.setAttribute(l, 'style', 'width: 40%; ');
    this.renderer.appendChild(row1, l);
    
    if (a['p_fix'] == 'm_') this.renderer.appendChild(row2, this.getMsgDet (ii, a, 1));
    
    this.renderer.appendChild(div, row1);
    this.renderer.appendChild(div, row2);
}

// MESSAGE ACTIONS ELEMENTS      ////$$$
getItemsSelected (gID ) {
    let trRow = document.getElementById('tr_' + gID); if (trRow === null) {console.error('tr _' + gID); return}
    // this.getScrolPos(trRow);
    var list = this.clearInnerHTML ('r1_' + gID); if (list === null) return;

    const itemGrid = this.createElem ('ion-grid', gID, '', '', 'itemsClass');

    this.renderer.appendChild(itemGrid, trRow);
    this.renderer.appendChild(itemGrid, this.createElem ('ion-row', 'mr_' + gID)); // msg body
    this.renderer.appendChild(itemGrid, this.createElem ('ion-row', 'ar_' + gID)); // action
    this.renderer.appendChild(itemGrid, this.createElem ('ion-row', 'sr_' + gID)); // sms
    this.renderer.appendChild(itemGrid, this.createElem ('ion-row', 'hr_' + gID, '', '', 'historyDiv'));  // history
    
    this.renderer.appendChild(list, itemGrid);
    this.enDisItmSli (gID, true);
}
deselectAnItem (gID) {
    let id = this.gs.clickedItemId;
    let ei = document.getElementById(id); if (ei === null ) {console.error ("ei=" + id); id =  ''; return;}
    this.addRemClass_e (ei, 'itemWhite', this.gs.showByClass);
    this.addRemClass_e (ei, 'itemsClass', this.gs.hideByClass);
    this.deleteElement ('ar_' + id);
    this.deleteElement ('mr_' + id);
    this.deleteElement ('sr_' + id);
    this.deleteElement ('hr_' + id);
    this.hideUnhideElement ('cap2_' + id, 'block');
    this.enDisItmSli (gID, false);
}

enDisItmSli (gID, en) {
    let e = document.getElementById( gID + '_sl') as HTMLIonItemSlidingElement;
    if (e !== null) {e.disabled = en }
}

getMsgDet (ind: number, a, isHist) {
    let e = this.createElem ('div');
    const row = this.createElem ('ion-row');

    switch (a['format']) {
    case this.gs.MSGS_FORMAT_WAV:
    case this.gs.MSGS_FORMAT_MP3:
        e = this.getAudioEl ('https://' + a['url'], a['format'], '');
        this.renderer.setAttribute(row, 'style', 'text-align: center; background: white; width: 100%;');
        this.renderer.setAttribute(e, 'style', 'margin: 15px; width: 100%;');
    break;

    case  this.gs.MSGS_FORMAT_TXT:
        this.renderer.setAttribute(row, 'class', 'sms-display');

        if (isHist == 0) this.hideUnhideElement ('cap2_' + this.gs.getID (ind), 'none'); 
        e = this.createLableEl (a['body']) ;

        let s = '';
        if (isHist == 1) {s += 'font-size: 14px; margin: 5px auto;';}
        if (a['type'] == this.gs.MSGS_TYPE_SENT) {s += 'font-size: 14px; color: gray; background: white;';}
        else {s += 'background-color: #158ffe; color: #fff;';}
        this.renderer.setAttribute(row, 'style', s);
    break;

    case this.gs.MSGS_FORMAT_TIF: case this.gs.MSGS_FORMAT_PDF: case this.gs.MSGS_FORMAT_TIF_PDF: 
        e = this.getDocEl (a);
        this.renderer.setAttribute(row, 'class', 'item-m-img');
    break;

    default: console.error(a); break;
    }

    this.renderer.appendChild(row, e);
    return row;
}

createLableEl (val ) {
    const div = this.createElem ('ion-lable');
    div.innerHTML = val;  return div;
}

setCons (ind: number) {
    let user = this.gs.ITMS[ind]['a'][this.gs.conOffS];
    for(let ii = 0; ii < this.gs.ITMS.length; ii++){
    
    if ( this.gs.ITMS[ ii ]['a'][ this.gs.isLoaded] != 1 ) continue;
    // if ( this.gs.ITMS[ ii ]['a'][ this.gs.isVis] != 1 ) continue;
    if (this.gs.ITMS[ii]['a'][this.gs.conOffS] == user) {
        const a = this.gs.getAssocMsgArray (ii);
        a['cname'] = this.gs.refrence;
        this.gs.setLStorageItem(ii);
        this.setInnerHDat ('cap1_'  + this.gs.getID (ii), this.gs.refrence);
    }
    }
}

getCheckRow (checkbox, l, chkBoxID, active, clas, toggle, cap) {
    let item;  let txt;
    this.renderer.setAttribute(checkbox, 'slot', 'start');
    if (active == true) this.renderer.setProperty(checkbox, 'checked', '');
    
    if (l != '') {
      item = this.getEL ('ion-item' + (clas != '' ? ';; class = ' + clas : ''));
      this.renderer.appendChild(item, checkbox);
      txt = this.createElem ('ion-label', '', l);
      this.renderer.appendChild(item, txt);
    }
    else if (cap !== '') {
        item = this.createElem ('ion-toolbar');
        this.renderer.appendChild(item, checkbox);
        txt = this.createElem ('ion-label', '', '');
        this.renderer.appendChild(item, txt);

        let es = 'ion-input ;; id = ' + chkBoxID + '0' + ' ;; name = ' + this.gs.ICO_MAIL;
        es += ' ;; class = uvm-title ;; placeholder = ' + cap
        let inp = this.getEL ( es);

        this.renderer.appendChild(item, inp);
    }
    return item;
}

// SEGMENT ELEMENTS      ////$$$
createGSsigsTab () {
    var d = this.clearInnerHTML ('fdiv'); if (d === null) return;
    const segs = this.getSegment ('segsMsgs');
    this.renderer.appendChild(d, segs);
    this.getMsgsFilters (segs);
    this.createSegs (segs);
    return segs;
}
createSegs ( segs) {
    for(let ii = 0; ii < this.gs.GS.length; ii++){
        this.renderer.appendChild(segs, 
            this.getSegBut (this.gs.GS[ii][this.gs.GS_cap_offset], 'segbid_' + ii, this.gs.GS[ii][this.gs.GS_icon_offset]));
        if (this.gs.selectedSegm == this.gs.GS[ii][this.gs.GS_cap_offset]) {this.renderer.setAttribute(segs, 'value', this.gs.GS[ii][this.gs.GS_cap_offset]);}
    }
    this.updateGSbadges();
}
getSegBut (value, id, ico ) {
    const but = this.createElem ('ion-segment-button', id) ;
    this.renderer.setAttribute(but, 'value', value);
    this.renderer.setAttribute(but, 'layout', 'icon-star');
    this.renderer.setAttribute(but, 'style', 'min-height: 30px; min-width: 33%;');

    const l = this.createElem ('ion-lable', '', value) ;
    this.renderer.setAttribute(l, 'style', 'margin: 3px;');

    const badge = this.createElem ('ion-badge', 'segid_' + value ) ;
    // this.renderer.setAttribute(badge, 'style', 'font-size: 12px; margin: 2px; min-width: 20px');
    this.renderer.setProperty(badge, 'color', 'success');

    if (value == 'All') this.renderer.setProperty(badge, 'color', 'dark');
    if (value == 'Bin') this.renderer.setProperty(badge, 'color', 'white');
    if (value == 'Flg') this.renderer.setProperty(badge, 'color', 'secondary');
    if (value == 'New') this.renderer.setProperty(badge, 'color', 'warning');
    if (value == 'Audio') this.renderer.setProperty(badge, 'color', 'medium');
    if (value == 'Text') this.renderer.setProperty(badge, 'color', 'medium');
    if (value == 'Pdf') this.renderer.setProperty(badge, 'color', 'medium');

    let icon = this.getEL ('ion-icon ;; style = font-size: 16px; margin-left:-30px; margin: 2px;')

    this.setIconName (ico, icon);
    this.renderer.appendChild(but, icon);

    this.renderer.appendChild(but, l);
    this.renderer.appendChild(but, badge);
    return but;
}
updateGSbadges () {
    var e; 
    this.gs.resetGScounts ();
    for(let ii = 0; ii < this.gs.GS.length; ii++){
        this.sh_segbid (ii, this.gs.showByClass);
        if (this.gs.GS[ii][this.gs.GS_se_total_offset] == 0 && this.gs.GS[ii][this.gs.GS_cap_offset] != 'New') {
            this.sh_segbid (ii, this.gs.hideByClass);
        }
        else { this.setInnerHDat ('segid_' + this.gs.GS[ii][this.gs.GS_cap_offset], this.gs.GS[ii][this.gs.GS_se_total_offset]); }
    }
    this.setInnerHDat ('segid_All', this.gs.msgsAllTotal);
    e = document.getElementById('segsMsgs') as HTMLIonSegmentElement ;  
    if (e !== null) {e.value = this.gs.selectedSegm;}
}

getMsgsFilters (segs) {
    this.gs.GS = new Array ();
    // let a = ['Close']; let aa = [this.gs.ICO_X];
    let a = ['All', 'New', 'Read', 'Mis', 'Sent'];
    let aa = [this.gs.ICO_STAR, this.gs.ICO_DOWNLOAD, this.gs.ICO_RED, this.gs.ICO_MISSED, this.gs.ICO_SEND];
    a.push ( 'Dials', 'InRec', 'DialR');
    aa.push ( this.gs.ICO_OUTCALL, this.gs.ICO_REC_CALL,  this.gs.ICO_REC_CALL);
    a.push ( 'Audio', 'Text', 'Pdf', 'Flg', 'Bin');
    aa.push ( this.gs.ICO_VOL_LOW, this.gs.ICO_CHAT,  this.gs.ICO_FAX, this.gs.ICO_FLG, this.gs.ICO_TRASH);
    for (let i = 0; i < a.length; i++) { 
        this.gs.getAddGS (a[i], aa[i], 1);
        if (this.gs.selectedSegm == a[i]) {this.renderer.setAttribute(segs, 'value', a[i]);}
    }
}
getSegment ( segID ) {  // ev listener to segment ID
    const item = this.createElem ('ion-item') ;
    const div = this.createElem ('div') ;

    const segs = this.createElem ('ion-segment', segID) ;
    // this.renderer.setAttribute(segs, 'scrollable', '');
    this.renderer.setProperty(segs, 'scrollable', 'true');
    this.renderer.setAttribute(segs, 'mode', 'ios');
    this.renderer.setAttribute(segs, 'class', 'segment-wrap');

    this.renderer.appendChild(div, segs);
    this.renderer.appendChild(item, div);
    return segs;
}
getSegsDIDset (ee) {
    let a = [ 'Filters',  'Routing', 'Notifs'];
    let aa = [ this.gs.ICO_FILTER,  this.gs.ICO_CALL, this.gs.ICO_NOTIF];
    let segs = this.getSegDIDs ( 'segsDID', a, aa, '');  
    this.renderer.appendChild(ee, segs);
    return segs;
}

// M SIDE MENUE      ////$$$
openMenu(m, isOpen) { 
    if (isOpen == 1) this.menuController.open(m);  
    else {this.menuController.close(m); } 
}
getMenuItem1 (label, name, color) {
    let item = this.getEL ('ion-item ;; class = menu-contact');

    let colo = color ? ' ;; color = ' + color : '';
    let es = 'ion-icon ;; name = ' + name + ' ;; slot = start' + colo;
    let icon = this.getEL ( es);

    this.renderer.appendChild(item, icon);
    this.renderer.appendChild(item, label);
    return item;
}
getMsgMenu (gID, mu) {
    let ind = this.gs.findInd (gID); if (ind == -1) return;
    const content = this.createElem ('ion-content'); 
    const list = this.createElem ('ion-list'); 
    const header = this.createElem ('ion-header');
    const toolbar = this.createElem ('ion-toolbar');
    const title = this.createElem ('ion-title', '', this.gs.ifIsPh(this.gs.ITMS[ind]['a'][this.gs.conOffS], 1));
    this.renderer.appendChild(header, toolbar);
    this.renderer.appendChild(toolbar, title);
    this.renderer.appendChild(content, list);
    this.renderer.appendChild(mu, header);
    this.renderer.appendChild(mu, content);
}

// OPTIONS SLIDES DISPLAY ELEMENTS      ////$$$
getSegDIDs ( segsID, a, aa, value) {
    const segs = this.getSegment (segsID);
    for(let ii = 0; ii < a.length; ii++){
        if (a[ii] == '') continue;
        let b = this.getSegBut (a[ii], '', aa[ii])
        this.renderer.appendChild(segs, b);
    }
    this.renderer.setAttribute(segs, 'value', value);
    this.gs.didSegSel = value;
    return segs;
}

// TOP and BUTTOM TAB       ////$$$

getTabBut (id, iname, cap, color) {
    const but = this.getEL ('ion-tab-button ;; style = max-width: 35px; ;; id = ' + id + ' ;; innerhtml = ' + cap  + color );
    let icon = this.getEL ('ion-icon ;; name = ' + iname + color );
    this.renderer.appendChild(but, icon);
    return but;
}
async closeMtabstop (e) { 
    this.sh_DIDsDivs (this.gs.hideByClass)
    this.X_clicked('didsIdsub');
    e.name = this.gs.ICO_ALERT;
}


// SMS       ////$$$

smsSentReturn (id, msg) {
    console.log(id)
    let s = id.replace(/smsTID/g,""); if (s == '') {console.error (id); return; }
    
    let txtId = s + '_txt';
    this.clearInnerHTML (txtId); 
    localStorage.removeItem(txtId);

    if (s == 'sms_g') this.sh_dsms (this.gs.hideByClass);
    else { this.deleteElement(s) }

    this.gs.presentToast(msg, 'success', 1000);
}

getSMStxta (id) {
    let e = this.createElem ('ion-textarea', id);
    // this.renderer.setAttribute(e, 'clear-input', 'true');
    this.renderer.setAttribute(e, 'class', 'sms-textarea-css');
    this.renderer.setProperty(e, 'value', this.gs.get_LS (id));
    this.renderer.setProperty(e, 'autocomplete', 'true');
    this.renderer.setProperty(e, 'spellcheck', 'true');
    this.renderer.setAttribute(e, 'maxlength', '160');
    this.renderer.setAttribute(e, 'rows', '4');
    this.renderer.setAttribute(e, 'placeholder', 'Type here...');
    e.addEventListener("ionChange", () => { this.gs.set_LS( id, e.value ); });

    // this.renderer.selectRootElement.invokeElementMethod(e, 'focus', []);
    return e;
}

getSubmit (but, val) {
    this.renderer.setAttribute(but, 'type', 'button');
    this.renderer.setAttribute(but, 'value', val);
    this.renderer.setAttribute(but, 'slot', 'end');
    const item = this.createElem ('ion-item');
    this.renderer.appendChild(item, but);
    return item;
}
  
getTextE (type, id, place, lab, isPhone, val) {
    let es = 'ion-input ;; id = ' + id + ' ;; type = ' + type + ' ;; placeholder = ' + place;
    es += ' ;; no-lines ;; value = ' + val + ' ;; style = padding: 20px; lenght: 100px;';
    es += ' ;; clear-input = true';
    let input = this.getEL ( es);

    if (isPhone == 1) {
        input.addEventListener("ionChange", () => { this.SMSfromChg( input ); });
        this.renderer.setAttribute(input, 'maxlength', '11');
        this.renderer.setAttribute(input, 'required', 'true');
        this.renderer.setAttribute(input, 'calss', 'sms-to-num');
        this.renderer.setAttribute(input, 'style', 'border-radius: 5px; --padding: 12px; max-width: 150px; margin: 5px;');
    }

    let l = this.createElem ('ion-lable', '', lab); 
    this.renderer.setAttribute(l, 'style', 'padding: 20px; lenght: 80px;');
    
    const item = this.createElem ('ion-item');
    this.renderer.appendChild(item, l);
    this.renderer.appendChild(item, input);
    return item;
}

SMSfromChg (e) {
    if (this.gs.if10dPhone (e.value) != '') {this.renderer.removeClass (e, 'red'); }
    else {this.renderer.addClass (e, 'red');}
}


// MAKE DID SETUP ELEMENTS      ////$$$
setSelDID (did) {
    if (this.getSelDID (did) != '') this.gs.didSel = did;
}
getSelDID (id) {
    if (this.gs.allUsersA.length == 0) { this.gs.presentToast('No IDs!.', 'warning', 1500); return ''; }
    if (id != '') {
        for (let i = 0; i < this.gs.allUsersA.length; i++) { if (this.gs.allUsersA[i] == id) return this.gs.allUsersA[i]; }
    }
    return '';
}
getTrfDestChange (id) { this.hideUnhideElement ('savTrf_item', 'block'); }
getTrfDest (res, ii, noDelay) {
    let s = ''; let ss = '';
    let item = this.createElem ('ion-toolbar');
    let g = this.createElem ('ion-grid');
    let row = this.createElem ('ion-row');
    
    let col1 = this.appendCol (row, '', '1', '', '');
    let col2 = this.appendCol (row, '', '2', '', '');
    let col3 = this.appendCol (row, '', '5', '', '');
    let col4 = this.appendCol (row, '', '2', '', '');
    let col5 = this.appendCol (row, '', '2', '', '');
  
    if (ii != '0') {
        s = 'trf_'+ii+'_on'; this.renderer.appendChild(col1, this.createCheckEl (s, res[s]));
        s = 'trf_'+ii+'_delay'; this.renderer.appendChild(col2, this.createInputEl (s, res[s], '2', noDelay));
        s = 'trf_'+ii+'_dest'; this.renderer.appendChild(col3, this.createInputEl (s, res[s], '14', 0));
        s = 'trf_'+ii+'_tout'; this.renderer.appendChild(col4, this.createInputEl (s, res[s], '3', 0));
        
        s = 'trf_'+ii+'_flag'; ss = res[s] == 'C' ? '1' : res[s];
        this.renderer.appendChild(col5, this.createCheckEl (s, ss));
    }
    else {
        col1.innerHTML = "On";
        col2.innerHTML = "Delay";
        col3.innerHTML = "Destination";
        col4.innerHTML = "Wait";
        col5.innerHTML = "Confirm";
        let sty = 'font-size: 12px';
        this.renderer.setAttribute(col1, 'style', sty);
        this.renderer.setAttribute(col2, 'style', sty);
        this.renderer.setAttribute(col3, 'style', sty);
        this.renderer.setAttribute(col4, 'style', sty);
        this.renderer.setAttribute(col5, 'style', sty);
    }
    
    this.renderer.appendChild(item, g);
    this.renderer.appendChild(g, row);
    return item;
}
getTrfDests (a, sss) {
    let dest =''; let v = ''; let s = '';
    let ss = 'trf_'+sss+'_delay'; v = '0';
    let e = document.getElementById (ss) as HTMLIonInputElement ; if (e !== null) v = e.value.toString();
    if (! this.isNumber(v) || parseInt(v) < 0 || parseInt(v) > 60) v = '0';
    a.push ( v);
    
    ss = 'trf_'+sss+'_dest'; v = '';
    e = document.getElementById (ss) as HTMLIonInputElement ; if (e !== null) v = e.value.toString();
    if (v != '') {
        s = v + ';';
        let a = s.split (';');
        for (let i = 0; i < a.length ; i++) {
            s = a[i];
            if (s == '') continue;
            if (this.gs.ifIsPhOrExt(s, 0).length == 0) {
                this.gs.presentToast('Invalid Destination Number ' + s + ', DID NOT SAVE', 'warning', 1500); 
                return 0;
            } 
        }
        dest = v;
    }
    a.push ( v);
    
    ss = 'trf_'+sss+'_tout'; v = '30';
    e = document.getElementById (ss) as HTMLIonInputElement ; if (e !== null) v = e.value.toString();
    if (! this.isNumber(v) || parseInt(v)  < 4 || parseInt(v) > 60) {v = '30';}
    a.push ( v);
    ss = 'trf_'+sss+'_on'; v = '';
    let ee = document.getElementById (ss) as HTMLIonCheckboxElement ; 
    if (ee !== null) 
    a.push ( ee.checked);
    ss = 'trf_'+sss+'_flag'; v = '';
    ee = document.getElementById (ss) as HTMLIonCheckboxElement ; 
    if (ee !== null) a.push (ee.checked);
    return 1;
}
getUVMdiv (subID) {
    let div = this.clearInnerHTML ('dsac'); if (div === null) return;
    this.renderer.setAttribute(div, 'class', 'did-setup-div');
    switch (subID) {
    case 'Notifs':
        let item = this.createElem( 'ion-item', 'addsmsDiv');
        let but = this.getTabBut ('addsms', this.gs.ICO_ADD, 'Email/SMS', '');
        but.setAttribute('style', 'max-width:60px');
        this.renderer.appendChild(item, but);
        this.renderer.appendChild(div, item);
        this.renderer.appendChild(div, this.createElem ('div', 'addnotifs'));
    break;
    }
    return div;
}

getRoutForm () {
    let e = null; let v;  let ss = '';
    let a = new Array();  let aa = new Array();
    a.push (0);  // sch # 0 to 6
  
    e = document.getElementById ('active') as HTMLIonInputElement ; if (e === null) return '';
    a.push ( e.checked);
  
    e = document.getElementById ('wisper' + '_name') as HTMLIonInputElement ; if (e === null) return '';
    e.placeholder = "Name / Wisper This"
    a.push ( e.value.toString());
  
    e = document.getElementById ('wisper') as HTMLIonInputElement ; if (e === null) return '';
    a.push ( e.checked);
  
    ss = 'trfScr';
    e = document.getElementById (ss) as HTMLIonSelectElement ; if (e === null) return '';
    v = e.value.toString();
    aa = this.getSelectAr(ss);
    for (let i = 0; i < aa.length ; i++) {if (aa[i] == v) {a.push (i); break; }}
  
    ss = 'trfTypes';
    e = document.getElementById (ss) as HTMLIonSelectElement ; if (e === null) return '';
    v = e.value.toString();
    aa = this.getSelectAr(ss);
    for (let i = 0; i < aa.length ; i++) {if (aa[i] == v) { a.push (i); break; }}
    for (let ii = 1; ii <= 3; ii++) { if (this.getTrfDests (a, ii.toString ()) == 0) return ''; }
    if (this.getTrfDests ( a, 'df') == 0) return '';
  
    // save greetings
    return a.join('^');
}
getTrfs (res, keys, vals) {
    let div = this.createElem ('div');
    this.renderer.setAttribute(div, 'class', 'uvm-setups');
    let e; let item;  let ss = ''; let s = ''; 
  
    for (let i = 0; i < vals.length; i++) {s += keys[i] + ' - ' + vals[i]+ ' + ';}
  
    item = this.getEL ('ion-item ;; id = savTrf_item ;; style = display:none; color:red' );
    this.renderer.appendChild(div, item);
  
    let but = this.getTabBut ('savTrf', this.gs.ICO_RED, 'Save', ' ;; color = red');
    this.renderer.setAttribute(but, 'slot', 'end');
    this.renderer.appendChild(item, but); 
  
    e = this.getTxtCheck ('Active', 'active', res['active'] , '', 1, 1, 0, '', 0); this.renderer.appendChild(div, e);
    e = this.getTxtCheck ('Wisper', 'wisper', res['wisper'], '', 0, 1, 1, res['name'], 0); this.renderer.appendChild(div, e);
  
    ss = 'trfScr'; this.renderer.appendChild(div, this.getSelectEl(ss, this.getSelectAr(ss), res[ss]));
    ss = 'trfTypes'; this.renderer.appendChild(div, this.getSelectEl(ss, this.getSelectAr(ss), res[ss]));
  
    for (let i = 0; i < 4 ; i++) { // 0 =  title
      this.renderer.appendChild(div, this.getTrfDest (res, i.toString(), 0));
    }
 
    this.renderer.appendChild(div, this.getItLblEl ('', 'Not Answered Failover Destinations', 'setup-lables'));
    this.renderer.appendChild(div, this.getTrfDest (res, 'df', 1));
  
    // greetings
    // this.renderer.appendChild(div, this.getItLblEl ('', 'No Answer Greeting', 'setup-lables'));
    // if (this.gs.uvmGrsA.length > 0) this.renderer.appendChild(div, this.getUvmAudio ());
  
    return div;
}
getNotifForm () {
    let e = null; let s = '';
    let ei = 'addsms';
    let ee = document.getElementById (ei + '-00') as HTMLIonInputElement ; if (ee === null) return '';// s += ee.value + '-';
    e = document.getElementById (ei + '-0') as HTMLIonCheckboxElement ; if (e === null) return ''; s += e.checked + '-';
    e = document.getElementById (ei + '-1') as HTMLIonCheckboxElement ; if (e === null) return ''; s += e.checked + '-';
    e = document.getElementById (ei + '-2') as HTMLIonCheckboxElement ; if (e === null) return ''; s += e.checked + '-';
    e = document.getElementById (ei + '-3') as HTMLIonCheckboxElement ; if (e === null) return ''; s += e.checked + '-';
    e = document.getElementById (ei + '-4') as HTMLIonCheckboxElement ; if (e === null) return ''; s += e.checked + '-';
    e = document.getElementById (ei + '-5') as HTMLIonCheckboxElement ; if (e === null) return ''; s += e.checked + '-';
    e = document.getElementById (ei + '-6') as HTMLIonCheckboxElement ; if (e === null) return ''; s += e.checked + '-';
    e = document.getElementById (ei + '-7') as HTMLIonCheckboxElement ; if (e === null) return ''; s += e.checked + '-';
    e = document.getElementById (ei + '-8') as HTMLIonCheckboxElement ; if (e === null) return ''; s += e.checked + '-';

    let ss = ee.value.toString();
    if (ss.indexOf('@') > -1 ) {
        let a = this.gs.regxEmail.exec(ss);
        if (a === null || a.length == 0) {this.gs.presentToast('Invalid Email Address!', 'warning', 1500); return ''; }
        s = ss + '-' + s
    }
    else {
        let p = this.gs.ifIsPh(ss, 0);
        if (p.length != 10) {this.gs.presentToast('Invalid Phone Number! ' + p, 'warning', 1500); return ''; }
        s = p + '-' + s
    }
    return s;
}
getTxtCheck (l, eid, active, clas, toggle, listen, txtBoxTes, txt, exit) {
    let item= this.createElem ('ion-item');
    let checkbox;
    if (toggle && toggle == 1) checkbox = this.createElem ('ion-toggle', eid);
    else checkbox = this.createElem ('ion-checkbox', eid);
    this.renderer.setAttribute(checkbox, 'slot', 'start');
    if (active == true) this.renderer.setProperty(checkbox, 'checked', '');
    if (listen === undefined) listen = 1;
    if (listen == 1) checkbox.addEventListener("ionChange", () => { this.getTrfDestChange( eid ); });
    this.renderer.appendChild(item, checkbox);

    if (l != '') {
        if (clas != '') this.renderer.setAttribute(item, 'class', clas);
        this.renderer.appendChild(item, checkbox);
        this.renderer.appendChild(item, this.createElem ('ion-label', '', l));
    }
    
    if (txtBoxTes == 1) {
        let es = 'ion-input ;; id = ' + eid + '_name' + ' ;; name = ' + this.gs.ICO_MAIL;
        es += ' ;; class = uvm-title ;; placeholder = ' + txt + ' ;; value = ' + txt;
        let inp = this.getEL ( es);
        this.renderer.appendChild(item, inp);
        if (listen == 1) inp.addEventListener("ionChange", () => { this.getTrfDestChange( eid ); });
    }
    if (exit == 1) this.renderer.appendChild(item, this.getX_bar ('x_' + eid));  // id ??????????????
    return item;
}
getSelectAr (s) {
  let a = new Array;
  switch (s) {
  case 'trfScr':
    a[0] = 'No Screening';
    a[1] = 'Screen All the Calls';
    a[2] = 'Screen Calls with Caller ID';
    a[3] = 'Screen Calls with Blocked ID';
    break;
  case 'trfTypes':
    a[0] = 'Call All the Destinations Together';
    a[1] = 'Call One at A Time, from 1 to 3';
    break;
  }
  return a;
}

// LOGIN OUT       ////$$$
postUrl_error (error) {
    console.log("error: " + error);
    const fb = document.getElementById("fb") as HTMLInputElement;
    if (fb !== null) {fb.innerHTML = 'There was a problem,<br>Please try again.';}
}

getLogin() {
    const uame = document.getElementById("uname") as HTMLInputElement;
    const upsw = document.getElementById("upsw") as HTMLInputElement;
    const fb = document.getElementById("fb") as HTMLInputElement;

    // const rem = document.getElementById("rem") as HTMLInputElement;
    // const rphone = document.getElementById("rphone") as HTMLInputElement;
    // const remail = document.getElementById("remail") as HTMLInputElement;
    // this.gs.remv = rem.checked;
    // this.gs.phRecover = rphone.value;
    // this.gs.emRecover = remail.value;   

    this.gs.username = uame.value;
    this.gs.upsw = upsw.value;

    if (this.gs.upsw.length < 6 ) { fb.innerHTML = 'Invalid Password Lenght (min 6 chrs)'; return; }
 
    //  this.gs.set_LS('upsw', this.encode(this.gs.duuid, this.gs.upsw));
     this.gs.set_LS('uname', this.gs.username);
    
    // if (isSI == 1) {
    //     let a;
    //     if (this.gs.emRecover != '') {
    //         a = this.gs.regxEmail.exec(this.gs.emRecover );
    //         if (a === null || a.length == 0) {s = s + 'Invalid Email!<br>'}
    //     }
    //     if (this.gs.phRecover != '') {
    //         if (this.gs.if10dPhone (this.gs.phRecover) == '') {s = s + 'Invalid Phone Number!<br>';}
    //     }
    // }
    // if (s != '') {fb.innerHTML  = s; return;} 

}

// private secureKey: string;
// private secureIV: string;

// async encode (key, data) {
//     await this.generateSecureKeyAndIV(key);
//     this.aes256.encrypt(this.secureKey, this.secureIV, data)
//     .then(res => {console.log('Encrypted Data: ',res); return res;})
//     .catch((error: any) => console.error(error));
//     return '';
// }

// async decode (key, data) {
//  await this.generateSecureKeyAndIV(key);
//  this.aes256.decrypt(this.secureKey, this.secureIV, data)
//  .then(res => {console.log('Decrypted Data : ',res); return res;})
//  .catch((error: any) => console.error(error));
//  return '';
// }

// async generateSecureKeyAndIV(key) {
//     this.secureKey = await this.aes256.generateSecureKey(key); // Returns a 32 bytes string
//     this.secureIV = await this.aes256.generateSecureIV(key); // Returns a 16 bytes string
//  }







        getUvmAudio () {  // not used
    if (this.gs.uvmGrsA.length == 0)  return ; 
    let sel = 0;
    let div = this.createElem ('div', 'grsList');
    this.renderer.setAttribute(div, 'style', 'font-size: 12px;');
    let item = this.createElem ('ion-item'); 

    let sele = this.select_El ('grsList_', this.gs.uvmGrsA[sel]['disp'], this.gs.uvmGrsA);
    sele.addEventListener("ionChange", () => { this.getAudioList( sele.value ); });

    this.renderer.appendChild(item, sele);
    this.renderer.appendChild(div, item);
    let d = this.createElem ('div', 'uvmAud');
    let e = this.getAudioEl ( this.gs.uvmGrsA[sel]['ser'] + this.gs.uvmGrsA[sel]['fn'], this.gs.uvmGrsA[sel]['format'], '');
    this.renderer.setAttribute(e, 'style', 'max-height: 32px; margin: 10px; width: 80%;');
    this.renderer.appendChild(d, e);
    this.renderer.appendChild(div, d);
    // this.renderer.appendChild(div, this.getUvmAudioRec());
    return div;
}

getIdsListDiv (didList) {
    let tool = this.createElem ('ion-toolbar');
    this.renderer.appendChild(tool, didList);
    this.renderer.appendChild(tool, this.buttons_El ('slot="start"', '', '---', '---', '---'));
    this.renderer.appendChild(tool, this.buttons_El ('slot="end"', '', '---', '---', '---'));
    let div = this.createElem ('div');
    this.renderer.appendChild(div, tool);
    return div;
}

SmsFromSelect (from, la, frmID) {
    let div = this.createElem ('div');
    let item = this.getEL ('ion-item ;; style = text-align: center;' );
    let e = this.getEL ('ion-lable ;; innerhtml = ' + la + ' ');

    this.renderer.appendChild(item, e);
   
   
    this.renderer.setAttribute(e, 'style', 'margin: 10px; width: 150px;');
   


    this.renderer.appendChild(item, this.select_El (frmID, from, this.gs.smsUserAr));
    this.renderer.appendChild(div, item);
    return div;
}

getSelectEl (id, a, selectedInd) {
    const item = this.createElem ('ion-item'); 
    let sel = this.select_El (id, a[selectedInd], a);
    sel.addEventListener("ionChange", () => { this.getTrfDestChange('trf_'); });
    this.renderer.appendChild(item, sel);
    return item;
}

getTab (id, icon, lab, b?) {  
    const but = this.createElem ('ion-tab-button', id);
    
    if (lab != '') this.renderer.appendChild(but, this.createElem ('ion-label', '', lab));
    if (b !== undefined) this.renderer.appendChild(but, this.createElem ('ion-badge', '', b));
    let ico = this.getEL ('ion-icon ;; name = ' + icon + (lab != '' ? ' ;; size = small' : '') );

    this.renderer.appendChild(but, ico);
    return but;
}

//////////////////////////////////////////

// for inside the tolbar

select_El (id, val, a) {
    let sel = this.createElem ('ion-select', id); 
    this.renderer.setAttribute(sel, 'interface', 'action-sheet');
    this.renderer.setProperty(sel, 'okText', 'Accept');
    this.renderer.setProperty(sel, 'value', val);

    for (let i = 0; i < this.gs.smsUserAr.length; i++) {
        this.renderer.appendChild(sel, this.createElem ('ion-select-option', id + '_' + i, a[i]));
    }
    return sel;
}

buttons_El (butsA, butA, icoA, imgA, bdgA) {
    const buts = this.getEL ('ion-buttons' + ';; class = act-buts ;; ' + butsA);
    const but = this.getEL ('ion-button' + butA);
    this.renderer.appendChild(buts, but);
    if (icoA != '---') this.renderer.appendChild(but, this.getEL ('ion-icon' + ';;' + icoA));
    if (imgA != '---') this.renderer.appendChild(but, this.getEL ('img' + ';;' + imgA));
    if (bdgA != '---') this.renderer.appendChild(but, this.getEL ('ion-badge' + ';;' + bdgA));
    return buts;
}

getEL (ss) {
    let le = 0; let at = ''; let v = '';
    // ss = ss.replace(/(\\ )/gm, "^~^~^"); ss = ss.replace(/(\^\~\^\~\^)/gm, " ");
    ss = ss.replace(/(\r\n|\n|\r)/gm, "");
    
    let a = ss.trim().split(';;');
    if (! a[0] || a[0] == '') return null;
    let e = this.createElem (a[0].trim());

    for (let i = 1; i < a.length; i++) {
        if (a[i].trim() == '') continue;
        a[i] = a[i].replace(/("|')/gm, "");
        if (a[i] == '') continue;
        le = a[i].indexOf ('=');
        if (le == -1) { at = a[i]; v = ''; } else { at = a[i].substring(0, le); v = a[i].substring(le + 1); }

        at = this.cleanTag (at);
       
        switch (at.toLowerCase()) {
        case 'innerhtml': e.innerHTML = v.trim() ; return e;
        case 'placeholder': e.innerHTML = v.trim(); return e;
        case 'name' : v = this.cleanTag (v); this.setIconName (v, e); return e;
        default: break;
        }

        v = this.cleanTag (v);
        this.renderer.setAttribute(e, at, v);
    }
    return e;
}

cleanTag (s) {
    s = s.trim();
    s = this.trimChar(s, '"');
    s = this.trimChar(s, "'");
    return s;
}

trimChar(s, charToRemove) {
    while(s.charAt(0)==charToRemove) { s = s.substring(1); }
    while(s.charAt(s.length-1)==charToRemove) { s = s.substring(0,s.length-1); }
    return s;
}














// let keys    = document.querySelectorAll('.keyboard_wrapper .key .row span'),
//     keyPad  = document.querySelector('.keyboard_wrapper .key'),
//     display = document.querySelector('.keyboard_wrapper .display');

// if(keys && keyPad && display)
// {
//     let capsLockMode = false;
//     keys.forEach(key=>
//     {
//         key.addEventListener('click', function()
//         {
//             // console.log(this.innerText);
//             if(this.classList.contains('caps'))
//             {
//                 this.classList.toggle('active');
//                 keyPad.classList.toggle('uppercase');

//                 capsLockMode ? capsLockMode = false : capsLockMode = true;
//             }
//             else if (this.classList.contains('backspace')){
//                 let str = display.innerText;
//                 display.innerText = str.substring(0, (str.length-1));
//             }else{
//                 if(capsLockMode)
//                 {
//                     display.innerText += this.dataset.key.toUpperCase();
//                 }else{
//                     display.innerText += this.dataset.key.toLowerCase();
//                 }
//             }
//         });
//     });
// }










//   if (buts.hasChildNodes()) {
//     let children = buts.childNodes[0].childNodes;
//     for (let i = 0; i < children.length; i++) {
//       console.log(children[i].nodeName)
//       // console.log(children[i].nodeValue)
//       // console.log(children[i].nodeType)
//       console.log(children[i].textContent)
//     }
//   }


//  executeFunctionByName(functionName, context , args ) {
//     var args = Array.prototype.slice.call(arguments, 2);
//     var namespaces = functionName.split(".");
//     var func = namespaces.pop();
//     for(var i = 0; i < namespaces.length; i++) {
//       context = context[namespaces[i]];
//     }
//     return context[func].apply(context, args);
//   }
//    myAddFunction(a,b){
//    return a+b;
//   }
//    c = this.executeFunctionByName("myAddFunction", window, '3,4'); //7









// autocomplete​
// Type	"off" ｜ "on" ｜ "name" ｜ "honorific-prefix" ｜ "given-name" ｜ "additional-name" ｜ "family-name" 
// ｜ "honorific-suffix" ｜ "nickname" ｜ "email" ｜ "username" ｜ "new-password" ｜ "current-password" 
// ｜ "one-time-code" ｜ "organization-title" ｜ "organization" ｜ "street-address" ｜ "address-line1" 
// ｜ "address-line2" ｜ "address-line3" ｜ "address-level4" ｜ "address-level3" ｜ "address-level2" 
// ｜ "address-level1" ｜ "country" ｜ "country-name" ｜ "postal-code" 
// ｜ "cc-name" ｜ "cc-given-name" ｜ "cc-additional-name" ｜ "cc-family-name" ｜ "cc-number" ｜ "cc-exp" 
// ｜ "cc-exp-month" ｜ "cc-exp-year" ｜ "cc-csc" ｜ "cc-type" ｜ "transaction-currency" ｜ "transaction-amount"
//  ｜ "language" ｜ "bday" ｜ "bday-day" ｜ "bday-month" ｜ "bday-year" ｜ "sex" ｜ "tel" ｜ "tel-country-code"
//   ｜ "tel-national" ｜ "tel-area-code" ｜ "tel-local" ｜ "tel-extension" ｜ "impp" ｜ "url" ｜ "photo"
// Default	'off'

// autocorrect​	"off" ｜ "on" Default	'off'
// autofocus​ Default	false
// clearInput​

  // "date" ｜ "datetime-local" ｜ "email" ｜ "month" ｜ "number" ｜ "password" ｜ "search" 
    // ｜ "tel" ｜ "text" ｜ "time" ｜ "url" ｜ "week"

// pattern
// spellcheck



}
